import React, {useEffect, useState} from 'react';
import EmptyState from "components/EmptyState/EmptyState";
import usefetchdata from "hooks/usefetchdata";
import MediaQuery from "react-responsive";
import CardMission from "components/card/mission";
import Cardmissionmobile from "components/card/cardmissionmobile";
import ApiDatabase from "server";
import {dateToEpoch} from "../../../helper/helper";
import useTitle from "../../../hooks/TitleManager";

const Completed = () => {
    useTitle({ title: "Missions - Terminées" });
    const [dataMission, setDataMission] = useState([])
    const [endMission, setEndMission] = useState([])
    const [isWaiting, setIsWaiting] = useState(true);

    useEffect(() => {
        ApiDatabase.getMissions({},
            (data) => {
                setDataMission(data)
                setIsWaiting(false)
            },
            (err) => {
                console.warn(err)
            }
        )
    }, [])

    useEffect(() => {
        let tampon = []
        for (let m in dataMission) {
            const d0 = dateToEpoch(new Date())
            const d2 = dateToEpoch(new Date(dataMission[m].duration?.dateend))
            if (d0.getTime() > d2.getTime()) {
                tampon.push(dataMission[m])
            }
        }
        setEndMission(tampon)
    }, [dataMission])
    return (
        <>
            <MediaQuery minWidth={770}>
                {
                    isWaiting ? (
                        <>
                            {
                                [1, 2, 3, 4, 5].map((i, index) => (
                                    <CardMission key={index} data={i} isWaiting={isWaiting}/>
                                ))
                            }
                        </>
                    ) : (
                        <>
                            {
                                endMission.length ?
                                    endMission.map(
                                        (item, index) =>
                                            <>
                                                <CardMission key={index} data={item}/>
                                            </>
                                    )
                                    :
                                    <EmptyState type={'mission_done'}/>
                            }
                        </>
                    )
                }
            </MediaQuery>
            <MediaQuery maxWidth={769}>
                {
                    isWaiting ? (
                        <>
                            {
                                [1, 2, 3, 4, 5].map((i, index) => (
                                    <Cardmissionmobile key={index} data={i} isWaiting={isWaiting}/>
                                ))
                            }
                        </>
                    ) : (
                        <>
                            {
                                endMission.length ?
                                    endMission.map(
                                        (item, index) =>
                                            <>
                                                <Cardmissionmobile key={index} data={item}/>
                                            </>
                                    )
                                    :
                                    <EmptyState type={'mission_done'}/>
                            }
                        </>
                    )
                }
            </MediaQuery>

        </>
    );
};

export default Completed;